<template>
  <div class="container">
    <head-nav-bar
      title="查看就诊卡"
      :fixed="true"
      @click-left="$router.go(-1)"
    />
    <div class="mt-header-nav">
      <div class="barcode">
        <barcode
          :value="form.cardNo"
          :options="barcode_option"
          tag="svg"
        ></barcode>
      </div>
      <div class="kong"></div>
      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardholderName"
          readonly
          label="患者姓名："
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.relationTypeDesc"
          label="与本人关系："
          readonly
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardholderBirthDate"
          readonly
          label="出生日期："
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardholderSexName"
          readonly
          label="性别："
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardholderContactPhoneProcted"
          label="手机号码："
          readonly
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardTypeDesc"
          readonly
          label="卡类型："
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          label-class="tr"
          v-model="form.cardNo"
          label="就诊卡号："
          readonly
        />
      </van-cell-group>
      <!-- QrCodeText -->
      <div v-if="form.qrCodeText" class="qr-code">
        <qrcode
          v-if="form.qrCodeText"
          :value="form.qrCodeText"
          :options="{ size: 120 }"
        ></qrcode>
        <span class="health-no">电子健康卡</span>
      </div>

      <div class="footer-actions">
        <van-button size="small" @click="onDel">解除绑定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Button, Dialog, Toast } from "vant";
import Barcode from "@xkeshi/vue-barcode";
import VueQrcode from "@xkeshi/vue-qrcode";
export default {
  name: "userContactInfo",
  components: {
    Barcode,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [VueQrcode.name]: VueQrcode
  },
  data() {
    return {
      title: "添加就诊人",
      // barcodes: "12345789",
      barcode_option: {
        displayValue: true, //是否默认显示条形码数据
        //textPosition  :'top', //条形码数据显示的位置
        background: "#fff", //条形码背景颜色
        valid: function(valid) {
          console.log(valid);
        },
        width: "2px",
        height: "55px",
        fontSize: "22px" //字体大小
      },
      form: {},
      imgurl: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.form.id = this.$route.query.Id;
      if (this.form.id) {
        this.getInfo();
      }
    },
    getInfo() {
      this.$post("Contact_Info", { Id: this.form.id })
        .then(res => {
          this.form = res.data;
          this.imgurl = "data:image/jpeg;base64," + this.form.qrCodeText;
        })
        .catch(() => {});
    },
    onDel() {
      Dialog.confirm({
        message: "确认解除绑定该就诊人吗？"
      })
        .then(() => {
          this.$post("Contact_Del", { Id: this.form.id }).then(() => {
            Toast.success("解绑成功！");
            this.$router.push({ name: "userContactList", replace: true });
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.barcode {
  text-align: center;
}
.qr-code {
  text-align: center;
  margin: 5px 0;
  padding-bottom: 10px;
  .health-no {
    display: block;
    font-size: 14px;
    margin-top: -10px;
  }
}
</style>
